<template>
  <ui-heading twoCols allowSticky background="white" :isSpecific="isSpecific">
    <template #suptitle="{ isSticky }">
      <p v-if="surtitle && !isSticky" class="mb-1">{{ surtitle }}</p>
    </template>
    <template #default="{ isSticky }">
      <h1
        class="title has-text-weight-bold sticky-heading__title"
        :class="{
          'is-5': $media.mobile,
          'is-4': ($media.tablet && !$media.widescreen) || isSticky,
          'is-3': $media.widescreen && !isSticky
        }"
      >
        <span class="sticky-heading__title-content">
          {{ title }}&nbsp;<span
            v-if="isSpecific"
            class="sticky-heading__icon-container"
            :class="{ 'sticky-heading__icon-container--sticky': isSticky }"
            >&nbsp;<img :src="require('@/assets/icon-specific.svg')"
          /></span>
        </span>
      </h1>
    </template>
    <template #actions="{ isSticky }">
      <slot name="actions" :isSticky="isSticky"></slot>
    </template>
  </ui-heading>
</template>
<script>
import UiHeading from '@/components/ui/heading'
export default {
  components: { UiHeading },
  props: {
    surtitle: String,
    title: String,
    isSpecific: Boolean
  }
}
</script>

<style lang="scss" scoped>
.sticky-heading {
  &__icon-container {
    white-space: nowrap;
    vertical-align: middle;
    line-height: 0;
    margin-left: $space-4px * -1;

    @include widescreen {
      position: relative;
      top: 5px;
      margin-left: $space-8px * -1;

      &--sticky {
        position: relative;
        top: 0;
        margin-left: $space-4px * -1;
      }
    }
  }
}
</style>